// URLs y texto para compartir. Siempre se comparten las URLs /share/..., que
// sirve Flask con las etiquetas Open Graph; nunca las de la SPA (WhatsApp y
// Facebook no ejecutan JS y no verían la vista previa).

const baseUrl = () => window.location.origin;

export const activityShareUrl = (id) => `${baseUrl()}/share/activity/${id}`;

export const empresaShareUrl = (slug) =>
  `${baseUrl()}/share/empresa/${encodeURIComponent(slug)}`;

export const activityShareText = (activity) =>
  `¡Mira esta experiencia en BokerHub! ${activity.title}${
    activity.location ? ` en ${activity.location}` : ''
  }`;

export const empresaShareText = (businessName) =>
  `Conoce a ${businessName} en BokerHub y reserva sus actividades`;

export const whatsappHref = (text, url) =>
  `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`;

export const facebookHref = (url) =>
  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

export const xHref = (text, url) =>
  `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;

// Web Share solo se ofrece en dispositivos táctiles (móvil/tableta).
export const canNativeShare = () =>
  typeof navigator !== 'undefined' &&
  typeof navigator.share === 'function' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(pointer: coarse)').matches;

export const copyText = async (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const area = document.createElement('textarea');
  area.value = text;
  area.setAttribute('readonly', '');
  area.style.position = 'fixed';
  area.style.opacity = '0';
  document.body.appendChild(area);
  area.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(area);
  if (!ok) throw new Error('copy failed');
};
